export default {
  namespaced: true,
  state     : () => ({
    width : 0,
    height: 0,
  }),
  mutations: {
  },
  actions: {
    initialize({ state, commit }) {
    },
  },
};
